import { SurveyParams } from './SurveyCollector';
import { fromPairs, isEmpty, omit, toPairs } from 'ramda';
const START_QUESTION_ANSWER_PARAM = 'startQuestionAnswer';
export type StartQuestionParams = { startQuestionAnswer?: string; };
export type UrlSurveyParams = { surveyParams: SurveyParams; searchParams: any; startQuestionParams: StartQuestionParams; };

export const acquireParamsFromUrl = (currentUrl: string): UrlSurveyParams => {
  const url = new URL(currentUrl);

  const surveyId = url.pathname.slice(1);
  if (isEmpty(surveyId)) {
    throw new Error('Unknown survey id');
  }

  // @ts-ignore
  const parsedSearchParams: any = fromPairs(Array.from(url.searchParams));

  const surveyParams: SurveyParams = {
    surveyId,
  };

  if (parsedSearchParams.lang) {
    surveyParams.surveyLanguage = parsedSearchParams.lang;
  }

  const startQuestionParams: StartQuestionParams = {startQuestionAnswer: parsedSearchParams[START_QUESTION_ANSWER_PARAM],};

  const searchParams = omit(['lang', START_QUESTION_ANSWER_PARAM], parsedSearchParams);

  return {surveyParams, searchParams, startQuestionParams,};
};

export const createSurveyUrl = (API_URI, surveyParams, searchParams = {}) => {
  const urlSearchParams = new URLSearchParams('');
  const paramsAsPars = toPairs(searchParams);

  if (surveyParams.surveyLanguage) {
    paramsAsPars.unshift(['lang', surveyParams.surveyLanguage]);
  }

  paramsAsPars.forEach(([key, value]) =>
    urlSearchParams.set(key, value as string)
  );

  const searchParamsAsString = urlSearchParams.toString();

  return [
    `${API_URI}/survey/${surveyParams.surveyId}`,
    searchParamsAsString ? `?${searchParamsAsString}` : '',
  ].join('');
};
